import Axios from "axios";

function Team() {}

Team.prototype.list = async function (filter = {}) {
  return await Axios.get("/users/teams", {
    params: filter,
  });
};

Team.prototype.members = async function (filter = {}) {
  return await Axios.get("/users/teams/members", {
    params: filter,
  });
};

Team.prototype.create = async function (team) {
  return await Axios.post("/teams", team);
};

Team.prototype.get = async function (id) {
  return await Axios.get("/teams/" + id);
};

Team.prototype.update = async function (team, id) {
  return await Axios.put("/teams/" + id, team);
};

Team.prototype.delete = async function (id) {
  return await Axios.delete("/teams/" + id);
};

Team.prototype.createUser = async function (user, userId, teamId) {
  let route = "/teams/" + teamId + "/user/";
  route += userId || "";

  return await Axios.put(route, user, {
    headers: { "community-id": user.community },
  });
};

// Expose Singleton
export default new Team();



// WEBPACK FOOTER //
// ./src/services/Team.js